import { useFormikContext } from 'formik'

import { FormActions } from '../../../Form'
import { APPOINTMENT_FORM_FIELD_NAME } from '../AppointmentFormModal.constants'
import { getIsAppointmentFormSubmittable } from '../AppointmentFormModal.utils'
import { getHasAppointmentFormInvitee } from '../AppointmentFormModal.utils.participants'

function AppointmentFormModalActions({ submitProps, ...restProps }) {
  const { values } = useFormikContext()

  return (
    <FormActions
      {...restProps}
      submitProps={{
        ...submitProps,
        disabled: !getIsAppointmentFormSubmittable(values),
        title: getHasAppointmentFormInvitee(
          values[APPOINTMENT_FORM_FIELD_NAME.participants]
        )
          ? 'Appointment.FormSaveAndInviteKey'
          : submitProps.title,
      }}
    />
  )
}

export default AppointmentFormModalActions
